import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tags', standalone: true })
export class TagsPipe implements PipeTransform {
  transform(value: string): any {

    //verifcar se o valor é nulo ou indefinido
    if (value === null || value === undefined) {
      return '';
    }
    // faz um case, se 'alto-padrao' retorna 'Alto Padrão', se 'destaque-venda' retorna 'Destaque Venda', se 'destaque-locacao' retorna 'Destaque Locação', se 'lancamento' retorna 'Lançamento', se 'em-obras' retorna 'Em Obras', se 'pronto' retorna 'Pronto', se 'lancamento-em-obras' retorna 'Lançamento Em Obras', se 'lancamento-pronto' retorna 'Lançamento Pronto', se 'pronto-em-obras' retorna 'Pronto Em Obras', se nenhum dos casos acima, retorna o valor original
    switch (value) {
      case 'destaque-venda':
        return 'Destaque Venda';
      case 'destaque-locacao':
        return 'Destaque Locação';
      case 'destaque-investimento':
        return 'Destaque Investimento'
      case 'alto padrao':
        return 'Alto Padrão';
      //se nenhum dos casos acima, retorna o valor original
      default:
        return value;
    }
  }
}
